import ModifierSingleSelect from "./ModifierSingleSelect";
import ModifierMultiSelect from "./ModifierMultiSelect";

export default {
  ModifierSingleSelect,
  ModifierMultiSelect,
};
